import { render, staticRenderFns } from "./oea-config.vue?vue&type=template&id=b6d8d3a8&scoped=true"
import script from "./oea-config.vue?vue&type=script&lang=js"
export * from "./oea-config.vue?vue&type=script&lang=js"
import style0 from "./oea-config.vue?vue&type=style&index=0&id=b6d8d3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8d3a8",
  null
  
)

export default component.exports